import { Component } from '@angular/core';
import { OrderConfirmationComponent } from 'gung-standard';

@Component({
  selector: 'colmec-order-confirmation',
  templateUrl: './colmec-order-confirmation.component.html',
  styleUrls: ['./colmec-order-confirmation.component.scss'],
  standalone: false
})
export class ColmecOrderConfirmationComponent extends OrderConfirmationComponent {}
